import { Component, Host, h, Prop, Element, Event, EventEmitter, Listen, Watch } from '@stencil/core';

/**
 * @slot heading - The heading's text with html.
 *
 * @part tab - The component's button element.
 */

@Component({
  tag: 'o2-tab',
  styleUrl: 'tab.scss',
  shadow: true,
})
export class O2Tab {
  @Element() el: HTMLO2TabElement;

  /**
   * Assigns o2-tab-content panel with its equal property name. String must be equal per o2-tabs component
   */
  @Prop() panel: string;

  /**
   * Defines tab heading. Use it every time except custom o2-tab content making.
   */
  @Prop() heading?: string;

  /**
   * Defines actually selected tab.
   */
  @Prop({ reflect: true }) selected?: boolean = false;

  @Watch('selected')
  selectedChangedHandler(newVal: boolean) {
    if (newVal) {
      this.o2Selected.emit({ selected: this.panel });
    }
  }

  /**
   * Fire o2Selected event on tab click.
   */
  @Event() o2Selected!: EventEmitter<any>;

  /**
   * Event emitted on tab click.
   */
  @Event() o2Click!: EventEmitter<any>;

  @Listen('click')
  protected handleClick() {
    this.o2Selected.emit({ selected: this.panel });
    this.o2Click.emit();
  }

  render() {
    const tabsComponent = this.el.closest('o2-tabs');
    const underline = tabsComponent ? tabsComponent.getAttribute('type') === 'underline' : false;
    
    return (
      <Host role="tab">
        <div id={`tab-${this.panel}`} class={`o2-tab ${underline ? 'o2-tab--underline' : ''}`} part="tab" tabindex="0" aria-selected={`${this.selected}`} aria-controls={`tab-panel-${this.panel}`}>
          {this.heading ? <span class="o2-tab__heading">{this.heading}</span> : <slot name="heading"></slot>}
        </div>
      </Host>
    );
  }
}
